;(function () {
  CF.ready(function () {
    const urlParams = new URLSearchParams(window.location.search)
    const viewParam = urlParams.get('view')
    const invitationParam = urlParams.get('invitation_id')

    const formEl = document.querySelector('[data-cf-form]')
    const cfForm = formEl.cfForm

    const postalCodeForm_PostalCode = document.querySelector('#postal-code-form .p-postal-code'),
      postalCodeForm_Region = document.querySelector('#postal-code-form .p-region'),
      postalCodeForm_Locality = document.querySelector('#postal-code-form .p-locality')

    initFormStep()

    // カラムのキーを格納
    const columnLabels = []
    document.querySelectorAll('[data-cf-column-key]').forEach((el) => {
      const key = el.dataset.cfColumnKey
      const labelEl = el.closest('.cf-field-container[data-cf-field-type="group"]')
        ? el.closest('.cf-field-container[data-cf-field-type="group"]').querySelector('.part-label p')
        : null
      const label = labelEl ? labelEl.textContent : null

      if (label && !(label in columnLabels)) {
        columnLabels.push({ label, key })
      }
    })

    const columnValues = {}
    columnLabels.forEach((data) => {
      columnValues[data.label] = '-'
    })

    // ------------------------------------------------------------------
    // フォームスタイルの初期化
    // ------------------------------------------------------------------
    function initFormStep() {
      // コンテナにクラス付与
      formEl.querySelectorAll('.cf-field-container').forEach((container) => {
        const labelEl = container.querySelector('legend')
        const isRequired = container.classList.contains('is-required')
        let badgeEl = isRequired ? `<span>*</span>` : ''
        if (labelEl) {
          const labelHTML = `<div class="part-label"><p>${labelEl.textContent}${badgeEl}</p></div>`
          container.insertAdjacentHTML('afterbegin', labelHTML)
          if (labelEl.textContent.includes('利用規約・プライバシーポリシー')) {
            container.querySelector('.cf-enum-field__choice > span').innerHTML = `
              <a href="/pages/terms-of-service" target="_blank">利用規約</a>・<a href="/pages/privacy-policy" target="_blank">プライバシーポリシー</a>に同意する
            `
          }
        }

        // パスワード入力にタイプ切り替え
        const passwordInput = container.querySelector('[type="password"]')
        if (passwordInput) {
          const toggleButton = document.createElement('button')
          toggleButton.type = 'button'
          toggleButton.classList.add('password-toggle')
          toggleButton.addEventListener('click', () => {
            if (passwordInput.type === 'password') {
              passwordInput.type = 'text'
              toggleButton.classList.add('is-disabled')
            }
          })
          const wrapper = passwordInput.closest('.cf-field')
          if (wrapper) wrapper.appendChild(toggleButton)
        }
      })

      // ------------------------------------------------------------------
      // 日付フィールドの日本語化＋並び替え（年→月→日）
      // ------------------------------------------------------------------
      function reorderDateFields() {
        formEl.querySelectorAll('.cf-date-field--inline-inputs').forEach((wrap) => {
          const parts = Array.from(wrap.querySelectorAll('.cf-select-wrap'))
          if (parts.length !== 3) return

          const monthWrap = parts[0]
          const dayWrap = parts[1]
          const yearWrap = parts[2]

          // ラベルを日本語に
          wrap.querySelectorAll('select').forEach((sel) => {
            const firstOpt = sel.querySelector('option')
            if (!firstOpt) return
            if (firstOpt.textContent === 'Year') firstOpt.textContent = '年'
            if (firstOpt.textContent === 'Month') firstOpt.textContent = '月'
            if (firstOpt.textContent === 'Day') firstOpt.textContent = '日'
          })

          // 並び替え（年→月→日）
          wrap.innerHTML = ''
          wrap.appendChild(yearWrap)
          wrap.appendChild(monthWrap)
          wrap.appendChild(dayWrap)
        })
      }

      reorderDateFields()
    }

    // ------------------------------------------------------------------
    // 値変更時イベント
    // ------------------------------------------------------------------
    formEl.addEventListener('cf:field_changed', (event) => {
      const label = event.target
        .closest('.cf-field-container[data-cf-field-type="group"]')
        .querySelector('.part-label p').textContent
      const key = event.detail.columnKey
      let value = event.detail.value

      // 複合形式まとめ
      if (key === 'first_name' || key === 'last_name') {
        value = `${cfForm.getFieldValue('last_name')} ${cfForm.getFieldValue('first_name')}`
      } else if (key === 'first_name_kana' || key === 'last_name_kana') {
        value = `${cfForm.getFieldValue('last_name_kana')} ${cfForm.getFieldValue('first_name_kana')}`
      } else if (key === 'birth_year' || key === 'birth_month' || key === 'birth_day') {
        value = `${cfForm.getFieldValue('birth_year')}年${cfForm.getFieldValue('birth_month')}月${cfForm.getFieldValue('birth_day')}日`
      } else if (key === 'event') {
        value = value.join(',')
      } else if (key === 'password') {
        value = '*'.repeat(value.length)
      }

      // オプトイン
      if (key === 'email_marketing_consent') {
        value = value.marketing_state === 'SUBSCRIBED' ? '希望する' : '希望しない'
      }

      // 郵便番号
      if (key === 'default_address.zip') {
        postalCodeForm_PostalCode.value = value
        postalCodeForm_PostalCode.dispatchEvent(new KeyboardEvent('keyup'))
        event.target.addEventListener('blur', () => {
          formEl.cfForm.setFieldValue('default_address.province', postalCodeForm_Region.value)
          formEl.cfForm.setFieldValue('default_address.city', postalCodeForm_Locality.value)
        })
      }

      columnValues[label] = value
    })

    // ------------------------------------------------------------------
    // ステップ遷移時
    // ------------------------------------------------------------------
    formEl.addEventListener('cf:step_changed', () => {
      initFormStep()
      // 再描画時も並び替えを再適用
      formEl.querySelectorAll('.cf-date-field--inline-inputs').forEach((wrap) => {
        const parts = Array.from(wrap.querySelectorAll('.cf-select-wrap'))
        if (parts.length !== 3) return
        const monthWrap = parts[0]
        const dayWrap = parts[1]
        const yearWrap = parts[2]
        wrap.innerHTML = ''
        wrap.appendChild(yearWrap)
        wrap.appendChild(monthWrap)
        wrap.appendChild(dayWrap)
      })
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    })

    // ------------------------------------------------------------------
    // フォーム送信時
    // ------------------------------------------------------------------
    formEl.addEventListener('cf:form_submitted', () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    })
  })
})()
